<template>
  <v-dialog
    v-model="dialog"
    :width="$vuetify.breakpoint.mdAndUp ? '800px' : '600px'"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn outlined color="primary" v-bind="attrs" v-on="on">{{
        $t('btn_cap_create_prod')
      }}</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h6 primary--text">
          {{ $t('title_form_create_prod') }}
        </span>
      </v-card-title>
      <v-card-subtitle class="pt-2 pt-md-4">
        <span>
          {{ $t('title_form_create_prod_sub') }}
        </span>
      </v-card-subtitle>
      <v-card-text>
        <v-form ref="productCreate">
          <v-row justify="center" align="center">
            <v-col cols="11">
              <v-row>
                <v-col cols="12" md="6" class="p-0">
                  <v-form ref="nameAdd">
                    <div>
                      <div>
                        {{ $t('cap_form_create_prod_name') }}
                      </div>
                      <div>
                        <span
                          v-if="nameForm.error"
                          class="caption error--text"
                          >{{ $t('cap_msg_en_required') }}</span
                        >
                      </div>
                      <div v-for="(value, key) in nameMulti" :key="key">
                        <v-row class="pt-0 align-center" no-gutters>
                          <v-col cols="2">
                            <v-avatar
                              size="25"
                              class="white--text"
                              color="primary"
                            >
                              {{ key }}
                            </v-avatar>
                          </v-col>
                          <v-col cols="8">
                            <span class="pl-2">
                              {{ value }}
                            </span>
                          </v-col>
                          <v-col cols="2" class="justify-start align-start">
                            <v-btn text @click="onNameDelete(key)">
                              <v-icon color="primary">mdi-close-circle</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                      <div>
                        <v-row>
                          <v-col cols="4">
                            <v-select
                              v-model="nameForm.lang"
                              :items="$store.state.tenant.lang"
                              solo
                              dense
                            ></v-select>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              v-model="nameForm.name"
                              :counter="100"
                              :rules="[
                                (v) =>
                                  v.length <= 100 ||
                                  this.$t('cap_counter_validation')
                              ]"
                              :placeholder="$t('cap_form_create_prod_name')"
                              persistent-hint
                              outlined
                              single-line
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-btn
                              class="text-capitalize primary--text text-left"
                              block
                              text
                              @click="onNameAdd"
                            >
                              {{ $t('btn_cap_add_pricing') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-form>

                  <v-form ref="descAdd">
                    <div>
                      <div>
                        {{ $t('cap_form_create_prod_desc') }}
                      </div>
                      <div>
                        <span
                          v-if="descForm.error"
                          class="caption error--text"
                          >{{ $t('cap_msg_en_required') }}</span
                        >
                      </div>
                      <div v-for="(value, key) in descMulti" :key="key">
                        <v-row class="pt-0 align-center" no-gutters>
                          <v-col cols="2">
                            <v-avatar
                              size="25"
                              class="white--text"
                              color="primary"
                            >
                              {{ key }}
                            </v-avatar>
                          </v-col>
                          <v-col cols="8">
                            <span class="pl-2">
                              {{ value }}
                            </span>
                          </v-col>
                          <v-col cols="2" class="justify-start align-start">
                            <v-btn text @click="onDescDelete(key)">
                              <v-icon color="primary">mdi-close-circle</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                      <div>
                        <v-row>
                          <v-col cols="4">
                            <v-select
                              v-model="descForm.lang"
                              :items="$store.state.tenant.lang"
                              solo
                              dense
                            ></v-select>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              v-model="descForm.desc"
                              :placeholder="$t('cap_form_create_prod_desc')"
                              persistent-hint
                              outlined
                              single-line
                              dense
                            ></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-btn
                              class="text-capitalize primary--text text-left"
                              block
                              text
                              @click="onDescAdd"
                            >
                              {{ $t('btn_cap_add_pricing') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-form>

                  <v-autocomplete
                    v-model="form.category"
                    :rules="rules.required"
                    :items="$store.state.tenant.categories"
                    :item-text="locale"
                    item-value="en"
                    filled
                    chips
                    :hint="$t('cap_form_create_prod_category')"
                    multiple
                    outlined
                    persistent-hint
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="onRemoveCategory(data.item)"
                      >
                        {{ formatMulti(data.item) }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content
                          v-text="data.item"
                        ></v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="formatMulti(data.item)"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>

                  <v-autocomplete
                    v-model="form.menu"
                    :items="$store.state.tenant.menus"
                    :item-text="locale"
                    item-value="en"
                    filled
                    chips
                    :hint="$t('cap_form_create_prod_where')"
                    multiple
                    outlined
                    persistent-hint
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="onRemoveMenu(data.item)"
                      >
                        {{ formatMulti(data.item) }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content
                          v-text="data.item"
                        ></v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="formatMulti(data.item)"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>

                  <v-autocomplete
                    v-model="form.branch"
                    :rules="rules.required"
                    :items="$store.getters['tenant/branches']"
                    filled
                    chips
                    :hint="$t('btn_cap_branches')"
                    multiple
                    outlined
                    persistent-hint
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="onRemoveBranch(data.item)"
                      >
                        {{ data.item }}
                      </v-chip>
                    </template>
                    <template v-slot:item="data">
                      <template v-if="typeof data.item !== 'object'">
                        <v-list-item-content
                          v-text="data.item"
                        ></v-list-item-content>
                      </template>
                      <template v-else>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="data.item"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            v-html="data.item.active"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <v-file-input
                    v-model="form.image"
                    :rules="rulesImage"
                    accept="image/png, image/jpg, image/jpeg, image/bmp"
                    :placeholder="$t('btn_cap_add_img')"
                    prepend-icon="mdi-camera"
                    outlined
                  ></v-file-input>
                  <v-col class="pl-8 mx-auto mt-n10">
                    <v-checkbox
                      :input-value="checkbox"
                      :label="
                        form.discount.percentage !== null
                          ? $t('cap_label_discount')
                          : $t('cap_label_no_discount')
                      "
                      @click.native="discountFeature()"
                    ></v-checkbox>
                  </v-col>
                  <v-row class="pl-8 mt-n10">
                    <v-col v-show="checkbox">
                      <v-text-field
                        v-model="form.discount.percentage"
                        prefix="%"
                        :label="
                          form.discount.percentage !== null
                            ? $t('cap_label_discount')
                            : $t('cap_label_no_discount')
                        "
                        :rules="PercentageRule"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <div>
                    <div>
                      {{ $t('cap_form_pricing') }}
                    </div>
                    <div>
                      <!--                        <span v-if="priceForm.error" class="caption error&#45;&#45;text">{{$t('cap_msg_price_required_info')}}</span>-->
                      <span
                        v-if="priceForm.error"
                        class="caption error--text"
                        >{{ $t('cap_msg_en_required') }}</span
                      >
                    </div>
                    <div v-for="(price, index) in form.pricing" :key="index">
                      <v-row class="pt-0 align-center">
                        <v-col cols="2">
                          <v-avatar
                            size="25"
                            class="white--text"
                            color="primary"
                          >
                            $
                          </v-avatar>
                        </v-col>
                        <v-col cols="4">
                          <span class="pl-2">
                            {{ formatMeasureUnit(price.measureUnit) }}
                          </span>
                        </v-col>
                        <v-col cols="4">
                          <span class="pl-2"> $ {{ price.price }} </span>
                        </v-col>

                        <v-col cols="2" class="justify-start align-start">
                          <v-btn text @click="onPriceDelete(index)">
                            <v-icon color="primary">mdi-close-circle</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                    <div>
                      <v-form ref="priceAdd">
                        <v-row v-if="Object.keys(form.pricing).length <= 3">
                          <v-col cols="4" class="pb-0">
                            <v-select
                              v-model="priceForm.lang"
                              :items="$store.state.tenant.lang"
                              solo
                              dense
                            ></v-select>
                          </v-col>
                          <v-col cols="4" class="pb-0">
                            <v-text-field
                              v-model="priceForm.measureUnit"
                              :placeholder="$t('cap_form_pricing_hint_mu')"
                              outlined
                              dense
                              single-line
                              required
                              :rules="measureUnitRule"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="4" class="pb-0">
                            <v-text-field
                              v-model="priceForm.price"
                              type="number"
                              min="0"
                              placeholder="$"
                              outlined
                              dense
                              single-line
                              required
                              :rules="priceRule"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="Object.keys(form.pricing).length <= 3"
                          no-gutters
                        >
                          <v-col cols="4" class="mx-auto">
                            <v-btn
                              color="primary"
                              class="text-capitalize white--text"
                              block
                              @click="onPriceAdd"
                            >
                              {{ $t('btn_cap_add_pricing') }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="error" cols="11">
              <v-alert type="error">
                {{ error.message }}
              </v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text class="primary--text" @click="onCancel">
          {{ $t('btn_txt_cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="white--text"
          :loading="$store.state.product.loadingItem"
          :disabled="$store.state.product.loadingItem"
          @click="onSubmit"
        >
          {{ $t('btn_cap_save') }}
          <template v-slot:loader>
            <span>{{ $store.state.product.uploadProgress }} % ...</span>
          </template>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    locale: {
      type: String,
      default: 'en'
    }
  },
  data() {
    return {
      dialog: false,
      error: null,
      priceForm: {
        lang: 'en',
        measureUnit: 'unit',
        price: 0,
        error: null
      },
      form: {
        branch: '',
        image: null,
        desc: {},
        menu: '',
        name: {},
        category: '',
        pricing: [],
        discount: {
          percentage: ''
        }
      },
      nameMulti: {},
      descMulti: {},
      priceMulti: [],
      nameForm: {
        lang: 'en',
        name: '',
        error: null
      },
      descForm: {
        lang: 'en',
        desc: '',
        error: null
      },
      rules: {
        required: [
          (v) =>
            Array.isArray(v)
              ? !!v && v.length > 0
              : !!v || this.$t('cap_msg_required')
        ]
      },
      rulesImage: [
        (value) => !value || value.size < 3000000 || this.$t('cap_rule_image')
      ],
      checkbox: false
    }
  },
  computed: {
    measureUnitRule() {
      return [
        (v) =>
          this.form.pricing.length > 0 ||
          !!v ||
          this.$t('cap_form_measure_required')
      ]
    },
    priceRule() {
      return [
        (v) => {
          const pattern = /^\d+(?:\.\d{1,2})?$/
          return pattern.test(v) || this.$t('cap_pricing_valid')
        },
        (v) =>
          this.form.pricing.length > 0 ||
          !!v ||
          this.$t('cap_form_price_required'),
        (v) => {
          return v > 0 || this.$t('cap_form_price_invalid')
        }
      ]
    },
    PercentageRule() {
      return [
        // (v) =>
        //   (!isNaN(parseFloat(v)) && v > 0 && v <= 100) ||
        //   this.$t('cap_form_percentage_rule'),
        (v) => !(v === 0) || this.$t('cap_form_percentage_invalid'),
        (v) =>
          this.checkbox !== true ||
          (!!v && v > 0 && v <= 100) ||
          this.$t('cap_form_percentage_rule')
      ]
    }
  },
  methods: {
    onRemoveCategory(item) {
      const index = this.form.category.indexOf(item)
      if (index >= 0) {
        this.form.category.splice(index, 1)
      }
    },
    onRemoveMenu(item) {
      const index = this.form.menu.indexOf(item)
      if (index >= 0) {
        this.form.menu.splice(index, 1)
      }
    },
    onRemoveBranch(item) {
      const index = this.form.branch.indexOf(item)
      if (index >= 0) {
        this.form.branch.splice(index, 1)
      }
    },
    onPriceAdd() {
      if (this.priceForm.measureUnit.trim() === '') {
        alert(this.$t('txt_space_measureUnit'))
      } else {
        if (this.$refs.priceAdd.validate()) {
          // console.log(this.priceForm.measureUnit)
          let flag = true
          if (this.priceMulti) {
            this.priceMulti.forEach((item) => {
              if (item.price === parseFloat(this.priceForm.price)) {
                item.measureUnit[this.priceForm.lang] =
                  this.priceForm.measureUnit
                flag = false
              }
            })
          }
          if (flag) {
            if (this.form.pricing.length >= 3) {
              alert(this.$t('txt_measure_unit_noti'))
            } else {
              const measureUnit = {}
              measureUnit[this.priceForm.lang] = this.priceForm.measureUnit
              this.priceMulti.push({
                measureUnit,
                price: parseFloat(this.priceForm.price)
              })
            }
          }
          this.priceForm = {
            lang: 'en',
            measureUnit: '',
            price: 1,
            error: null
          }
          this.form.pricing = this.priceMulti
        }
      }
    },
    onNameAdd() {
      this.nameForm.name = this.nameForm.name.trim()
      if (this.$refs.nameAdd.validate() && this.nameForm.name) {
        this.nameMulti[this.nameForm.lang] = this.nameForm.name
        this.nameForm = {
          lang: 'en',
          name: '',
          error: null
        }
      }
    },
    onDescAdd() {
      this.descForm.desc = this.descForm.desc.trim()
      if (this.$refs.descAdd.validate() && this.descForm.desc) {
        this.descMulti[this.descForm.lang] = this.descForm.desc
        this.descForm = {
          lang: 'en',
          desc: '',
          error: null
        }
      }
    },
    onNameDelete(key) {
      if (key in this.nameMulti) {
        this.$delete(this.nameMulti, key)
      }
    },
    onDescDelete(key) {
      if (key in this.descMulti) {
        this.$delete(this.descMulti, key)
      }
    },
    onPriceDelete(index) {
      if (index >= 0) {
        this.form.pricing.splice(index, 1)
      }
    },
    onCancel() {
      this.dialog = false
      this.form = {
        active: '',
        branch: '',
        image: null,
        desc: {},
        menu: '',
        name: '',
        category: '',
        pricing: [],
        discount: {
          percentage: ''
        }
      }
      this.priceForm = {
        lang: 'en',
        measureUnit: 'unit',
        price: 0,
        error: null
      }
      this.nameMulti = {}
      this.descMulti = {}
      this.priceMulti = []
      this.descForm = {
        lang: 'en',
        desc: '',
        error: null
      }
      this.nameForm = {
        lang: 'en',
        name: '',
        error: null
      }
      this.$refs.nameAdd.resetValidation()
      this.$refs.descAdd.resetValidation()
      this.$refs.productCreate.resetValidation()
      this.$refs.priceAdd.resetValidation()
    },
    onSubmit() {
      if (this.$refs.productCreate.validate()) {
        // en is required for MultiLang
        if (!('en' in this.nameMulti)) {
          this.nameForm.error = true
        } else if (
          !('en' in this.descMulti) &&
          Object.keys(this.descMulti).length > 0
        ) {
          this.descForm.error = true
        } else if (this.form.pricing.length < 1) {
          this.priceForm.error = true
        } else {
          this.form.pricing.forEach((item) => {
            if (!('en' in item.measureUnit)) {
              this.priceForm.error = true
            }
          })
          if (!this.priceForm.error) {
            this.form.name = this.nameMulti
            this.form.desc = this.descMulti
            if (typeof this.form.discount.percentage === 'string') {
              this.form.discount.percentage = parseFloat(
                this.form.discount.percentage
              )
            }
            if (this.checkbox === false) {
              this.form.discount.percentage = null
            }
            if (this.form.discount.percentage > 0) {
              this.checkbox = true
            }

            this.form.menu = this.formatEn(this.form.menu)
            this.form.category = this.formatEn(this.form.category)
            this.$store
              .dispatch('product/createProduct', this.form)
              .then(() => {
                this.onCancel()
              })
              .catch((error) => {
                this.error = error
              })
          }
        }
      }
    },
    formatMulti(value) {
      if (typeof value === 'object') {
        if (Object.prototype.hasOwnProperty.call(value, this.locale)) {
          return value[this.locale]
        } else {
          return value.en
        }
      } else {
        return value
      }
    },
    formatEn(value) {
      if (!value) {
        return []
      }
      return value.map((i) => {
        if (typeof i === 'object') {
          return i.en
        } else {
          return i
        }
      })
    },
    formatMeasureUnit(measureUnit) {
      if (typeof measureUnit !== 'object') {
        return measureUnit
      } else {
        const ordered = {}
        Object.keys(measureUnit)
          .sort()
          .forEach((key) => {
            ordered[key] = measureUnit[key]
          })
        return Object.values(ordered).join(' | ')
      }
    },
    discountFeature() {
      this.checkbox = !this.checkbox
      if (this.checkbox === false) {
        this.form.discount.percentage = null
      }
    }
  }
}
</script>
